<template>
  <div>
    <el-dialog :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true"
               height="70vh" width="750" @size-change="handleResizeChange" :body-padding="false"
               class="x-list-page-dialog common-dialog fixed-height-dialog-title" v-bind="$attrs"
               v-on="$listeners" @opened="handleOpened" @close="handleClose" ref="dialog" :title="title">
      <x-page-container class="x-list-page common-page-container toolbar-page-container">
        <template v-slot:header>
          <x-button-group :button-config="buttonConfig"></x-button-group>
        </template>
        <template v-slot:main>
          <x-table
            ref="xTable"
            border
            height="100%"
            :scroll-y="{enabled: true}"
            :seq-config="{startIndex: 0}"
            :columns="columns"
            :data="tableData"
            :menu-config="{body: {}, header: {}}"
          ></x-table>
        </template>
      </x-page-container>
    </el-dialog>
    <x-list-page-dialog
      ref="listPageDialog"
      height="70vh"
      width="750"
      :custom="false"
      :visible.sync="otherDialogVisible"
      :buttonConfig="otherDialogButtonConfig"
      :condition-config="otherDialogConditionConfig"
      :columns="otherDialogColumns"
      :tableSettingConfig="{storage: 'noStorage', columnDraggable: false}"
      :api="misConfigureListAll"
      :menu-config="{body: {}, header: {}}"
      :preset-query-params="presetQueryParams"
      :dynamic-statistics-config="{enabled: false}"
    ></x-list-page-dialog>
    <el-dialog :visible.sync="scopeDialogVisible"
               title="设置范围"
               height="120px"
               width="500px"
               :body-padding="true">
      <x-page-container>
        <template v-slot:header>
          <x-button-group :button-config="scopeButtonConfig"></x-button-group>
        </template>
        <template v-slot:sub>
          <x-condition :condition-config="scopeConditionConfig"></x-condition>
        </template>
      </x-page-container>
    </el-dialog>
    <el-dialog :visible.sync="saveDialogVisible"
               :title="saveDialogTitle"
               height="120px"
               width="500px"
               @close="saveConditionConfig.model.configureName = ''"
              :body-padding="true">
      <x-page-container>
        <template v-slot:header>
          <x-button-group :button-config="saveButtonConfig"></x-button-group>
        </template>
        <template v-slot:sub>
          <x-condition :condition-config="saveConditionConfig"></x-condition>
        </template>
      </x-page-container>
    </el-dialog>
  </div>
</template>

<script>
import {
  misConfigureListAll,
  misConfigureListUser,
  misConfigureUpdateScope,
  removeMisConfigure,
  saveTableColumnMsg,
  misConfigureExtensionSaveOrUpdate
} from '../../api/misConfigApi';
import {FIELD_TYPE_INPUT, FIELD_TYPE_SELECT} from '@/util/x-condition-constant';
import {OBJECT_TYPE_TABLE_SETTING, SCOPE_PRIVATE, SCOPE_PUBLIC} from '@/util/table-setting-constant';
import {getSysUser} from '@/util/user';
import {Notification} from'element-ui';
export default {
  name: 'XTableSettingDialog',
  inheritAttrs: false,
  props: {
    /**
     * 父组件的配置信息
     */
    baseMisConfigure: Object,
    /**
     * 当前表格用到样式
     */
    currentMisConfigure: Object,
    handleSelect: Function,
    title: {
      type: String,
      default: '表格样式'
    }
  },
  data() {
    return {
      menuConfig: null,
      scopeDialogVisible: false,
      saveDialogVisible: false,
      buttonConfig: {
        list: [
          {
            name: '选择',
            click: this.selectTableSetting
          },
          {
            name: '保存',
            click: this.showSaveDialog
          },
          {
            name: '另存为',
            click: this.showSaveDialogCopy
          },
          {
            name: '设置默认',
            click: this.setTableSettingDefault
          },
          {
            name: '取消默认',
            click: this.cancelTableSettingDefault
          },
          {
            name: '设置范围',
            click: this.setTableSettingScope
          },
          {
            name: '其它方案',
            click: () => { this.otherDialogVisible = true; }
          },
          {
            name: '删除',
            type: 'danger',
            click: this.deleteTableSetting
          }
        ]
      },
      columns: [
        {field: 'selection', type: 'radio', width: 40},
        {field: 'seq', type: 'seq', title: '序号', width: 50},
        {field: 'configureName', title: '名称', minWidth: 200},
        {field: 'creatorName', title: '创建人', width: 200},
        {
          field: 'defaultConfigure',
          title: '默认',
          width: 100,
          formatter: this.defaultConfigureFormatter
        },
        {
          field: 'scope',
          title: '范围',
          width: 100,
          formatter: ({cellValue}) => {
            if (cellValue === SCOPE_PUBLIC) {
              return '共享';
            }
            if (cellValue === SCOPE_PRIVATE) {
              return '私有';
            }
            return cellValue;
          }
        },
        {field: 'lastModifierTime', title: '修改时间', width: 180}
      ],
      tableData: [],
      scopeButtonConfig: {
        list: [
          {
            name: '确定',
            click: this.updateScope
          },
          {
            name: '取消',
            click: () => {
              this.scopeDialogVisible = false;
            }
          }
        ]
      },
      scopeConditionConfig: {
        model: {
          scope: ''
        },
        list: [
          {
            field: 'scope',
            label: '范围',
            type: FIELD_TYPE_SELECT,
            span: 12,
            options: [
              {label: '共享', value: SCOPE_PUBLIC},
              {label: '私有', value: SCOPE_PRIVATE}
            ]
          }
        ]
      },
      saveButtonConfig: {
        list: [
          {
            name: '确定',
            click: this.confirmSaveTableSetting
          },
          {
            name: '取消',
            click: () => {
              this.saveDialogVisible = false;
            }
          }
        ]
      },
      saveConditionConfig: {
        model: {
          configureName: ''
        },
        rules: {
          configureName: [{trigger: 'blur', required: true, message: '请输入名称'}]
        },
        list: [
          {
            field: 'configureName',
            label: '名称',
            type: FIELD_TYPE_INPUT,
            span: 12
          }
        ]
      },
      saveDialogTitle: '',
      otherDialogVisible: false,
      otherDialogButtonConfig: {
        list: [
          {
            name: '选择',
            click: this.selectOtherTableSetting
          },
          {
            name: '查询',
            click: this.searchOther
          },
          {
            name: '另存为',
            click: this.showOtherSaveDialogCopy
          },
          {
            name: '设置默认',
            click: this.setOtherTableSettingDefault
          }
        ]
      },
      otherDialogConditionConfig: {
        model: {
          configureName: ''
        },
        list: [
          {
            field: 'configureName',
            label: '显示名称',
            type: FIELD_TYPE_INPUT,
            span: 12
          }
        ]
      },
      otherDialogColumns: [
        {field: 'selection', type: 'radio', width: 40},
        {field: 'seq', type: 'seq', title: '序号', width: 50},
        {field: 'configureName', title: '名称', minWidth: 200},
        {field: 'creatorName', title: '创建人', width: 200},
        {
          field: 'defaultConfigure',
          title: '默认',
          width: 100,
          formatter: this.defaultConfigureFormatter
        },
        {field: 'lastModifierTime', title: '修改时间', width: 180}
      ],
      misConfigureListAll,
      saveRow: null
    };
  },
  methods: {
    searchOther() {
      this.$refs.listPageDialog.search();
    },
    showOtherSaveDialogCopy() {
      const row = this.$refs.listPageDialog.getListPage().getGridInstance().getRadioRecord();
      if (!row) {
        Notification.error('请选择记录');
        return;
      }
      this.otherDialogVisible = false;
      this.coreShowSaveDialog('另存为', row);
    },
    defaultConfigureFormatter({row}) {
      if (this.misConfigureExtension && this.misConfigureExtension.defaultConfigure === row.id) {
        return '默认';
      }
      return '';
    },
    handleResizeChange() {
      const xTable = this.$refs.xTable;
      if (xTable) {
        const grid = xTable.getGridInstance();
        grid.updateCellAreas();
        grid.recalculate(true);
      }
    },
    deleteTableSetting() {
      const sysUser = getSysUser();
      if (!sysUser) {
        Notification.error('用户未登录');
        return;
      }
      const row = this.$refs.xTable.getGridInstance().getRadioRecord();
      if (!row) {
        Notification.error('请选择记录');
        return;
      }
      if (row.userId + '' !== sysUser.id + '') {
        Notification.error('只能删除本用户创建的记录');
        return;
      }
      removeMisConfigure({ids: [row.id]}, {originResponse: false}).then((res) => {
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        Notification.success(res.msg);
        // 判断删除的是不是当前misConfigure
        if (this.currentMisConfigure && row.id === this.currentMisConfigure.id && this.handleSelect) {
          this.handleSelect({misConfigure: null, misConfigureExtension: this.misConfigureExtension});
        }
        this.searchUserMisConfig();
      });
    },
    showSaveDialog() {
      const sysUser = getSysUser();
      if (!sysUser) {
        Notification.error('用户未登录');
        return;
      }
      const row = this.$refs.xTable.getRadioRecord();
      if (!row) {
        Notification.error('请选择记录');
        return;
      }
      if (row.userId + '' !== sysUser.id + '') {
        Notification.error('只能修改本用户创建的记录');
        return;
      }
      this.coreShowSaveDialog('保存', row);
    },
    showSaveDialogCopy() {
      const sysUser = getSysUser();
      if (!sysUser) {
        Notification.error('用户未登录');
        return;
      }
      const row = this.$refs.xTable.getGridInstance().getRadioRecord();
      if (!row) {
        Notification.error('请选择记录');
        return;
      }
      this.coreShowSaveDialog('另存为', row);
    },
    coreShowSaveDialog(title, row) {
      this.saveRow = row;
      this.saveConditionConfig.model.configureName = row.configureName;
      this.saveDialogTitle = title;
      this.saveDialogVisible = true;
    },
    confirmSaveTableSetting() {
      if (this.saveDialogTitle === '保存') {
        this.saveTableSetting();
      } else {
        this.saveTableSettingCopy();
      }
    },
    saveTableSetting() {
      const row = this.saveRow;
      const params = {
        name: row.name,
        objectType: row.objectType,
        objectJson: row.objectJson,
        configureName: this.saveConditionConfig.model.configureName
      };
      if (row) {
        params.id = row.id;
        params.scope = row.scope;
      } else {
        params.scope = SCOPE_PRIVATE;
      }
      saveTableColumnMsg(params, {originResponse: false}).then((res) => {
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        Notification.success(res.msg);
        this.saveDialogVisible = false;
        this.searchUserMisConfig();
      });
    },
    saveTableSettingCopy() {
      const row = this.saveRow;
      if (!row) {
        return;
      }
      const params = {
        name: row.name,
        objectType: row.objectType,
        configureName: this.saveConditionConfig.model.configureName,
        scope: SCOPE_PRIVATE,
        objectJson: row.objectJson
      };
      saveTableColumnMsg(params, {originResponse: false}).then((res) => {
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        Notification.success(res.msg);
        this.saveDialogVisible = false;
        this.searchUserMisConfig();
      });
    },
    cancelTableSettingDefault() {
      const params = {name: this.baseMisConfigure.name};
      misConfigureExtensionSaveOrUpdate(params).then((response) => {
        const res = response.data;
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        this.searchUserMisConfig();
      });
    },
    setTableSettingDefault() {
      const row = this.$refs.xTable.getRadioRecord();
      if (!row) {
        return;
      }
      const params = {name: this.baseMisConfigure.name, defaultConfigure: row.id};
      misConfigureExtensionSaveOrUpdate(params).then((response) => {
        const res = response.data;
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        this.searchUserMisConfig();
      });
    },
    selectTableSetting() {
      const row = this.$refs.xTable.getGridInstance().getRadioRecord();
      if (!row) {
        return;
      }
      if (this.handleSelect) {
        this.handleSelect({misConfigure: row, misConfigureExtension: this.misConfigureExtension});
      }
      this.$refs.dialog.hide();
    },
    selectOtherTableSetting() {
      const row = this.$refs.listPageDialog.getListPage().getGridInstance().getRadioRecord();
      if (!row) {
        return;
      }
      if (this.handleSelect) {
        this.handleSelect({misConfigure: row, misConfigureExtension: this.misConfigureExtension});
      }
      this.otherDialogVisible = false;
      this.$refs.dialog.hide();
    },
    setOtherTableSettingDefault() {
      const row = this.$refs.listPageDialog.getListPage().getGridInstance().getRadioRecord();
      if (!row) {
        return;
      }
      const params = {name: this.baseMisConfigure.name, defaultConfigure: row.id};
      misConfigureExtensionSaveOrUpdate(params).then((response) => {
        const res = response.data;
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        this.searchUserMisConfig();
        this.$refs.listPageDialog.loadData();
      });
    },
    setTableSettingScope() {
      const sysUser = getSysUser();
      if (!sysUser) {
        Notification.error('用户未登录');
        return;
      }
      const row = this.$refs.xTable.getGridInstance().getRadioRecord();
      if (!row) {
        Notification.error('请选择记录');
        return;
      }
      if (row.userId + '' !== sysUser.id + '') {
        Notification.error('只能修改本用户创建的记录');
        return;
      }
      this.scopeDialogVisible = true;
      this.scopeConditionConfig.model.scope = row.scope;
    },
    updateScope() {
      const row = this.$refs.xTable.getGridInstance().getRadioRecord();
      if (row.scope === this.scopeConditionConfig.model.scope) {
        this.scopeDialogVisible = false;
        return;
      }
      misConfigureUpdateScope({id: row.id, scope: this.scopeConditionConfig.model.scope}, {originResponse: false}).then(res => {
        if (!res.isSuccess()) {
          Notification.error(res.msg);
          return;
        }
        this.scopeDialogVisible = false;
        Notification.success(res.msg);
        this.searchUserMisConfig();
      });
    },
    handleOpened() {
      this.$refs.xTable.getGridInstance().recalculate(true).then(() => {
        this.searchUserMisConfig();
      });
    },
    handleClose() {
      this.misConfigureExtension = null;
      this.tableData = [];
      this.currentPage = 1;
      this.total = 0;
    },
    searchUserMisConfig() {
      misConfigureListUser({name: this.baseMisConfigure.name, objectType: OBJECT_TYPE_TABLE_SETTING}).then((res) => {
        if (res.isFail()) {
          Notification.error(res.msg);
          return;
        }
        const data = res.data;
        this.misConfigureExtension = data.misConfigureExtension;
        this.tableData = data.list;
        // 设置当前选中的配置
        if (!this.currentMisConfigure) {
          return;
        }
        setTimeout(() => {
          for (const item of this.tableData) {
            if (item.id === this.currentMisConfigure.id) {
              this.$refs.xTable.getGridInstance().setRadioRow(item);
              break;
            }
          }
        });
      });
    }
  },
  computed: {
    presetQueryParams() {
      return {
        name: this.baseMisConfigure.name,
        scope: SCOPE_PUBLIC
      };
    }
  }
};
</script>
